import styled, { css } from 'styled-components';

import { respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

const columns = css`
    display: grid;
    grid-template-columns: 4fr 1fr 1.2fr 1.5fr 2.5fr 1fr;
    align-items: center;
    > :nth-child(2),
    > :nth-child(3) {
        justify-self: end;
    }
    > :nth-child(4),
    > :nth-child(5) {
        margin-left: 5rem;
    }
`;
export const LoadingHead = styled.div`
    ${columns};
    min-height: 5.2rem;
    font-size: 1.4rem;
    color: ${COLORS.textGray};
    white-space: nowrap;
    ${respondDown(Breakpoints.xl)`display: none;`}
`;
export const LoadingRow = styled.div`
    ${columns};
    padding: 0.8rem;
    min-height: 11.4rem;
    border: 0.1rem solid ${COLORS.transparent};
    border-radius: 0.5rem;
    ${respondDown(Breakpoints.xl)`
        grid-template-columns: 1fr;
        background: ${COLORS.surface};
        margin-bottom: 1.6rem;
        > * { margin-bottom: 1.6rem; }
        > :nth-child(n) { justify-self: stretch; margin-left: 0; }
    `}
`;
export const LoadingValue = styled.div`
    display: flex;
    align-items: center;
    min-height: 2.8rem;
    > span {
        display: none;
    }
    ${respondDown(Breakpoints.xl)`
        justify-content: space-between;
        > span { display: inline; color: ${COLORS.textGray}; line-height: 2.8rem; }
    `}
`;
export const LoadingActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 0.8rem;
`;
export const LoadingLogos = styled.div`
    display: flex;
    min-width: 12rem;
    justify-content: center;
    > :last-child {
        margin-left: -0.8rem;
    }
    ${respondDown(Breakpoints.md)`justify-content: flex-start;`}
`;
